import {productoActions} from "../../_actions";

import {history, TIPO_ENVIO} from '../../_helpers';
import {productoService} from "../producto.service";
import alertService from "./alert.service";
import http from "./http.service";
import {ahorroTotal, redondearMonto, totalConOfertas} from "../../_components/publica/utils/Oferta";

class CartService {

    cartProducts: any[] = [];

    constructor() {
        let storedProducts = localStorage.getItem("cartProducts");

        if (!!storedProducts) {
            this.cartProducts = JSON.parse(storedProducts);

            let productIds = this.cartProducts.map(it => it.id);

            if (productIds.length > 0) {
                http.post('/public/producto/disponibles', productIds)
                    .then(
                        (data: any) => {
                            if (data.removeIds && data.removeIds.length > 0) {
                                let filtered = this.cartProducts.filter(it => !data.removeIds.includes(it.id))

                                this.cartProducts = filtered;

                                alertService.msg("Algunos productos han sido eliminado de su carrito de compras ya que no se encuentran mas disponibles para la venta")
                            }

                            this.refrescarPrecios(data.precios);

                            localStorage.setItem("cartProducts", JSON.stringify(this.cartProducts));

                            productoActions.actualizoCartService();
                        },
                        (error: any) => console.error(error)
                    );
            }
        }
    }


    agregarItem = (product: any) => {

        // Ultimo freno del lado del cliente: una publicacion a consultar no tiene precio, y si
        // entra al carrito el checkout se arma con un total mal. Los botones de compra ya no se
        // pintan para estas publicaciones, pero el carrito tambien se llena desde el carrito
        // viejo del localStorage.
        if (product?.precioAConsultar === true) {
            alertService.error('Esta publicación tiene precio a consultar: el precio se arregla con el vendedor, no se compra por el sitio.');
            return;
        }

        let index = this.cartProducts.findIndex(it => it.id === product.id);

        if (index === -1) {
            if (this.cartProducts.length > 0) {
                let existiingSellerId = this.cartProducts[0].vendedor.id;

                if (existiingSellerId != product.vendedor.id) {
                    alertService.error('En el carrito de compras ya posees un producto de otro vendedor. Solo puedes comprar productos del mismo vendedor. Pueden realizar otra compra al vendedor despues que finalices la actual.')

                } else {
                    alertService.msg("Producto agregado al carrito. Ir a checkout", 'success', () => history.push('/checkout'));
                    this.cartProducts.push(product);
                }
            } else {
                alertService.msg("Producto agregado al carrito. Ir a checkout", 'success', () => history.push('/checkout'));
                this.cartProducts.push(product);
            }

            localStorage.setItem("cartProducts", JSON.stringify(this.cartProducts));
        } else {
            alertService.error('Este producto ya existe en el carrito');
        }

        productoActions.actualizoCartService();
    }

    algunProductoTieneEnvio = (): boolean => {
        return this.cartProducts.some(it => it.tipoEnvio == TIPO_ENVIO.ENVIO_A_COORDINAR);
    }

    clear = () => {
        this.cartProducts = [];

        localStorage.removeItem("cartProducts");

        productoActions.actualizoCartService();

    }

    agregarYComprar = (product: any) => {
        this.agregarItem(product);
        history.push('/checkout');
    }


    getCartSize = () => {
        if (this.cartProducts && this.cartProducts.length > 0) {
            return this.cartProducts.length
        }
        return 0;
    }

    /**
     * Lo que hay que pagar: el precio de oferta donde la haya, el de lista donde no.
     *
     * <p>Nunca `prod.precio` a secas. Ese es el precio tachado, y sumarlo dejaba al checkout
     * mostrando un total distinto del que termina cobrando MercadoPago — que arma su preferencia
     * con el precio que resuelve el back.
     */
    getTotal = () => {
        return totalConOfertas(this.cartProducts);
    }

    /** Lo que el carrito entero se ahorra por las ofertas. 0 cuando no hay ninguna. */
    getAhorro = () => {
        return ahorroTotal(this.cartProducts);
    }

    /** El total sin ningun descuento: es el numero que el checkout muestra tachado. */
    getTotalLista = () => {
        let total = 0;
        this.cartProducts.forEach((prod: any) => {
            total = total + Number(prod.precio || 0);
        });
        return redondearMonto(total);
    }

    /**
     * Pisa el precio y la oferta de cada renglon con lo que dice el server.
     *
     * <p>El carrito vive en el localStorage, asi que sus renglones pueden ser de hace semanas: el
     * precio pudo cambiar, o pudo empezar —o terminar— una oferta. Sin esto, el checkout mostraria
     * el precio viejo y MercadoPago cobraria el nuevo.
     *
     * <p>Se pisa `oferta` siempre, incluso con null: una promo que se vencio tiene que desaparecer
     * del carrito, no quedarse porque el server no mando nada en su lugar.
     */
    refrescarPrecios = (precios: any[]) => {
        if (!precios || precios.length === 0) return;

        const porId = new Map(precios.map((p: any) => [p.id, p]));

        this.cartProducts = this.cartProducts.map((prod: any) => {
            const fresco = porId.get(prod.id);
            if (!fresco) return prod;

            return {...prod, precio: fresco.precio, oferta: fresco.oferta ?? null};
        });
    }

    getCartProducts = () => {
        return this.cartProducts;
    }

    /*
     * `onError` no es opcional por comodidad: sin el, un error dejaba al checkout
     * con `loading`/`submitted` en true para siempre — el boton quedaba
     * deshabilitado y el spinner girando, sin manera de reintentar salvo recargar.
     */
    crearPreferencia = (values: any, onSuccess: any, onError?: any) => {
        values.ids = this.cartProducts.map(it => it.id)

        productoService.crearPreferencia(values)
            .then((data: any) => {
                onSuccess({preferenceId: data.preferenceId, showWallet: true});
            })
            .catch((error: any) => {
                alertService.error(error);
                if (onError) onError(error);
            })
    }

    crearCompraCash = (values: any, onSuccess: any, onError?: any) => {
        values.ids = this.cartProducts.map(it => it.id)

        productoService.crearCompraCash(values)
            .then((data: any) => {
                onSuccess({compraId: data.compraId, successCash: true});
                alertService.msg("La compra se ha realizado exitosamente")
                this.clear();
            })
            .catch((error: any) => {
                alertService.error(error);
                if (onError) onError(error);
            })
    }

    getMpKey = (): any => {
        if (this.cartProducts.length === 0) return undefined;
        else {
            const key = this.cartProducts[0].vendedor.mercadoPagoPublicKey;
            return key;
        }
    }

    tieneMercadoPago = (): boolean => {
        if (this.cartProducts.length === 0) return false;
        else {
            return this.cartProducts[0].vendedor.mercadoPagoHabilitado;
        }
    }


    remove = (product: any) => {

        this.cartProducts = this.cartProducts.filter(it => it.id !== product.id);

        localStorage.setItem("cartProducts", JSON.stringify(this.cartProducts));

        productoActions.actualizoCartService();
    }
}


const cartService = new CartService();

export default cartService;